import {FileDto} from './file';

export interface Comment {
  id: number;
  comment: string;
  /**
   * Date of creation in String format
   */
  createdDate: string;
}

export interface Form {
  id: number;
  code: string;
  name: string;
  formTypeId: number;
  formSubTypeId: number;
  active: boolean;
  questions: Question[];
  comments: Comment[];
}

export interface PosibleAnswer {
  id: number;
  code: string;
  description: string;
  requiresExplanation: boolean;
  color: string;
  commentsRequired?: boolean;
}

export type AttachmentFile = FileDto;

export interface QuestionAttachment {
  id: number;
  fileId: number;
  file: AttachmentFile;
  createdDate: string;
}

export interface TableDimensions {
  id: number;
  code: string;
  description: string;
}

export enum GroupOp {
  AND =   'AND',
  OR  =   'OR'
}

export enum ComparableOperator {
  Equal = "Equal",
  NotEqual = "NotEqual",
  Contains = "Contains",
  StartWith = "StartWith",
  EndWith = "EndWith",
  In = "In",
  GreaterThan = "GreaterThan",
  GreaterThanOrEqual = "GreaterThanOrEqual",
  LessThan = "LessThan",
  LessThanOrEqual = "LessThanOrEqual",
  IsNullOrEmpty = "IsNullOrEmpty",
  NotIsNullOrEmpty = "NotIsNullOrEmpty",
  Between = "Between",
  Empty = "Empty",
  Completed = "Completed",
}

export interface ConditionalItem {
  questionId: number;
  comparableOperator: ComparableOperator;
  comparableValue: any
}

export interface ConditionalGroup {
  operator: GroupOp;
  items: ConditionalItem[];
  childGroups: ConditionalGroup[];
}

export interface Question {
  id: number;
  code: string;
  description: string;
  detail: string;
  questionTypeId: number;
  isRequired: boolean;
  commentAllowed: boolean;
  commentRequired: boolean;
  attachAllowed: boolean;
  attachRequired: boolean;
  templateFileId: number;
  possibleAnswers: PosibleAnswer[];
  dimensions?: TableDimensions[];
  answerId?: number;
  answer: string;
  answerFiles: AttachmentFile[];
  attachments: QuestionAttachment[];
  comments: Comment[];
  conditionalGroup?: ConditionalGroup;
  questionGroupId?: number;
  questionGroup?: FormQuestionGroups;
  orderPosition?: number;
  dynamicFilterOperator?: boolean;//true -> AND | false -> OR
  questionOperatorId?: number;
}

export interface FormQuestionGroups {
  id: number;
  description?: string;
  orderPosition: number;
}